"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var imgSrcs_1 = require("./imgSrcs/imgSrcs");
var Logo = function (_a) {
    var logoType = _a.logoType, size = _a.size, props = __rest(_a, ["logoType", "size"]);
    var imgSrc = react_1.useMemo(function () {
        switch (logoType) {
            case "mesa":
                return imgSrcs_1.mesaLogoSrc;
            case "triangles":
                return imgSrcs_1.trianglesLogoSrc;
            case "triangles-svg":
                return imgSrcs_1.trianglesLogoSVGSrc;
            default:
                return imgSrcs_1.mesaLogoSrc;
        }
    }, [logoType]);
    var style = size ? { "width": size } : {};
    var finalStyle = (typeof props.style === "object" && props.style !== null) ? (__assign({ style: style }, props.style)) : (style);
    return react_1.default.createElement("img", __assign({ src: imgSrc, style: finalStyle }, props));
};
Logo.defaultProps = { logoType: "mesa" };
exports.default = Logo;
